import emailjs from 'emailjs-com';
import { formatPrice } from '../utils/productPricing';

const SERVICE_ID = 'service_7jorpxi';
// const SERVICE_ID = 'service_51provh';
const CUSTOMER_TEMPLATE_ID = 'template_1lchrds';
const ADMIN_TEMPLATE_ID = 'template_fe7lyjd'; // Replace with your actual admin template ID
const USER_ID = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;

const getShippingMethodName = (shippingMethod) =>
  shippingMethod?.servicelevel?.name ||
  shippingMethod?.service ||
  shippingMethod?.provider ||
  'Standard Shipping';

const getSelectedColorName = (selectedColor) =>
  typeof selectedColor === 'string'
    ? selectedColor
    : selectedColor?.name || selectedColor?.value || '';

const formatItemsList = (orderItems) =>
  orderItems
    .map((item) => {
      const colorName = getSelectedColorName(item.selected_color);
      return `${item.product_name}${colorName ? ` (${colorName})` : ''} - Qty: ${item.quantity} - ${formatPrice(item.price * item.quantity)}`;
    })
    .join('\n');

export const sendCustomerConfirmation = async (orderData, orderItems) => {
  const templateParams = {
    customer_name: orderData.customer_name,
    customer_email: orderData.customer_email,
    order_id: orderData.id.slice(0, 8),
    order_date: new Date().toLocaleDateString(),
    status: orderData.status,
    shipping_name: orderData.customer_name,
    shipping_address: orderData.shipping_address.address,
    shipping_city: orderData.shipping_address.city,
    shipping_state: orderData.shipping_address.state,
    shipping_zip: orderData.shipping_address.zipCode,
    items_list: formatItemsList(orderItems),
    subtotal: formatPrice(orderData.subtotal).slice(1),
    shipping_cost: formatPrice(orderData.shipping_cost).slice(1),
    shipping_method: getShippingMethodName(orderData.shipping_method),
    tax: formatPrice(orderData.tax).slice(1),
    total: formatPrice(orderData.total).slice(1),
    payment_intent_id: orderData.payment_intent_id
  };

  try {
    await emailjs.send(SERVICE_ID, CUSTOMER_TEMPLATE_ID, templateParams, USER_ID);
    console.log('Customer email sent successfully');
  } catch (error) {
    console.error('Customer email failed:', error);
  }
};

export const sendAdminNotification = async (orderData, orderItems) => {
  const templateParams = {
    order_id: orderData.id.slice(0, 8),
    order_date: new Date().toLocaleDateString(),
    status: orderData.status,
    customer_name: orderData.customer_name,
    customer_email: orderData.customer_email,
    shipping_name: orderData.customer_name,
    shipping_address: orderData.shipping_address.address,
    shipping_city: orderData.shipping_address.city,
    shipping_state: orderData.shipping_address.state,
    shipping_zip: orderData.shipping_address.zipCode,
    items_list: formatItemsList(orderItems),
    subtotal: formatPrice(orderData.subtotal).slice(1),
    shipping_cost: formatPrice(orderData.shipping_cost).slice(1),
    shipping_method: getShippingMethodName(orderData.shipping_method),
    tax: formatPrice(orderData.tax).slice(1),
    total: formatPrice(orderData.total).slice(1),
    payment_intent_id: orderData.payment_intent_id
  };

  try {
    await emailjs.send(SERVICE_ID, ADMIN_TEMPLATE_ID, templateParams, USER_ID);
    console.log('Admin notification sent');
  } catch (error) {
    console.error('Admin email failed:', error);
  }
};
// export const sendNewsletterWelcome = async (email) => {
//   try {
//     const response = await fetch('/api/send-email', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify({
//         to: email,
//         subject: 'Welcome to JmoLux Newsletter!',
//         html: `
//           <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto; padding: 20px;">
//             <div style="text-align: center; margin-bottom: 30px;">
//               <img src="https://wkjfxayobpgymnvwuxwo.supabase.co/storage/v1/object/public/general/logo_small_gold_.png" 
//                    alt="JmoLux Logo" 
//                    style="height: 60px; width: auto;" />
//             </div>
            
//             <h2 style="color: #D97706; text-align: center;">Welcome to JmoLux Newsletter!</h2>
//             <p>Thank you for subscribing to our exclusive updates.</p>
//             <p>You'll be the first to know about:</p>
//             <ul>
//               <li>New luxury collections</li>
//               <li>Exclusive offers and discounts</li>
//               <li>Special events and previews</li>
//             </ul>
//             <p>Welcome to the JmoLux family!</p>
            
//             <hr style="margin: 30px 0; border: none; border-top: 1px solid #ddd;">
//             <p style="font-size: 12px; color: #666; text-align: center;">
//               If you no longer wish to receive these emails, you can 
//               <a href="#">unsubscribe here</a>.
//             </p>
//           </div>
//         `,
//       }),
//     });

//     if (!response.ok) {
//       throw new Error('Failed to send welcome email');
//     }

//     console.log('Newsletter welcome email sent successfully');
//   } catch (error) {
//     console.error('Error sending newsletter welcome email:', error);
//     throw error;
//   }
// };
